/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Feature_HeaderInputs */

const en_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const de_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const fr_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalité`)
};

const es_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Característica`)
};

const it_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità`)
};

const nl_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functie`)
};

const pl_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcja`)
};

const fi_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuus`)
};

const da_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion`)
};

const sv_pricing_compare_feature_header = /** @type {(inputs: Pricing_Compare_Feature_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktion`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Pricing_Compare_Feature_HeaderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_feature_header = /** @type {((inputs?: Pricing_Compare_Feature_HeaderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Feature_HeaderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_feature_header(inputs)
	if (locale === "fr") return fr_pricing_compare_feature_header(inputs)
	if (locale === "es") return es_pricing_compare_feature_header(inputs)
	if (locale === "it") return it_pricing_compare_feature_header(inputs)
	if (locale === "nl") return nl_pricing_compare_feature_header(inputs)
	if (locale === "pl") return pl_pricing_compare_feature_header(inputs)
	if (locale === "fi") return fi_pricing_compare_feature_header(inputs)
	if (locale === "da") return da_pricing_compare_feature_header(inputs)
	if (locale === "sv") return sv_pricing_compare_feature_header(inputs)
	return en_pricing_compare_feature_header(inputs)
});